import CuriousPanda, {
  BillboardNavigation as BBN,
  GetFieldDictionary as GFD,
} from '@evidation/curious-panda';

import ComponentDictionary from './componentDictionary';
import React from 'react';

export const BillboardNavigation = BBN;
export const GetFieldDictionary = GFD;

const LocalCuriousPanda = props => {
  return (
    <CuriousPanda
      autoComplete="off"
      components={ComponentDictionary}
      froalaKey={process.env.REACT_APP_FROALA}
      {...props}
    />
  );
};

export default LocalCuriousPanda;



// WEBPACK FOOTER //
// ./src/components/CuriousPanda.js